module.exports = __webpack_public_path__ + "img/sport-pic1.349859cb.png";